import type { ReceiveUrlState } from './types';

export const DEFAULT_URL_STATE: ReceiveUrlState = {
  consignmentNumber: '',
  organization: '',
  originLocation: '',
  shipmentIdentification: '',
  search: ''
};
